module.exports = __webpack_public_path__ + "img/2_1-residenziale-edicola-1.e957cec7.png";